<template>
  <div class="order">
    <div class="top">
      <div class="querybox">
        <div>
          <p>订单编号：</p>
          <el-input
            v-model="queryParams.orderNo"
            placeholder="请输入订单编号"
            clearable
          ></el-input>
        </div>
        <div>
          <p>售后状态：</p>
          <el-select
            v-model="queryParams.applyRefundStatus"
            placeholder="请选择售后状态"
          >
            <el-option
              v-for="item in getDictDatas(DICT_TYPE.APPLY_REFUND_STATUS)"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div>
          <p>售后时间：</p>
          <!-- <el-date-picker
            v-model="value"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            @change="timeChange"
          >
          </el-date-picker> -->
          <el-date-picker
            v-model="value"
            align="right"
            type="date"
            placeholder="选择时间"
            :picker-options="pickerOptions"
            @change="timeChange"
          >
          </el-date-picker>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            class="reset-btn"
            @click="resetFn"
            >重置</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            class="search-btn"
            @click="search"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="content">
      <el-table :data="tableData" tooltip-effect="dark" style="width: 100%">
        <el-table-column
          prop="orderNo"
          label="订单编号"
          min-width="80"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="userNickName"
          label="售后人"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="goodsName"
          label="商品标题"
          min-width="100"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="goodsSkuName" label="规格信息" min-width="100">
        </el-table-column>
        <el-table-column prop="count" label="购买数量"> </el-table-column>
        <el-table-column prop="orderMoney" label="退款金额">
          <template slot-scope="{ row }">
            <!-- ￥{{ row.money }} -->
            <el-button class="textBlue-btn" @click="checkMoney(row)"
              >查看</el-button
            ></template
          >
        </el-table-column>
        <el-table-column
          prop="refundReason"
          label="退款原因"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="applyRefundStatus" label="售后状态">
          <template slot-scope="{ row }">
            <!-- {{ row.applyRefundStatus_dictText }} -->
            <el-button class="green-btn" v-if="row.applyRefundStatus === 1"
              >通过</el-button
            >
            <el-button class="blue-btn" v-else-if="row.applyRefundStatus === 0"
              >待审核</el-button
            >
            <el-button class="red-btn" v-else>拒绝</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="feedback" label="审核结果">
          <template slot-scope="{ row }">
            {{ row.feedback ? row.feedback : "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="售后时间" min-width="160">
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="150">
          <template slot-scope="{ row }">
            <el-button
              v-if="row.applyRefundStatus === 0"
              class="textOrange-btn"
              @click="goAgree(row)"
              >通过</el-button
            >
            <el-button
              v-if="row.applyRefundStatus === 0"
              class="textOrange-btn"
              @click="goRefuse(row)"
              >拒绝</el-button
            >
            <el-button class="textOrange-btn" @click="goDetails(row.orderId)"
              >订单详情</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
    <!-- 查看退款金额 -->
    <el-dialog
      :visible.sync="moneyVisible"
      width="30%"
      :before-close="moneyClose"
      :show-close="false"
    >
      <div slot="title" class="title">
        <p>退款金额</p>
        <span @click="moneyClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="money-box">
        <p>
          退款金额： <span style="color: #ff5d2f">￥{{ itemInfo.money }}</span>
        </p>
        <p>
          金额说明： <span>{{ itemInfo.moneyDescribe }}</span>
        </p>
      </div>
    </el-dialog>
    <!-- 同意退款 -->
    <el-dialog
      :visible.sync="agreeVisible"
      width="30%"
      :before-close="agreeClose"
      :show-close="false"
    >
      <div slot="title" class="title">
        <p>通过退款申请</p>
        <span @click="agreeClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="agree-box">
        <div>
          <p>退款金额：</p>
          <span style="color: #ff5d2f">￥{{ itemInfo.money }}</span>
        </div>
        <div>
          <p>金额说明：</p>
          <span>{{ itemInfo.moneyDescribe }}</span>
        </div>
        <div>
          <p>是否返回库存：</p>
          <el-radio-group v-model="isReturnStock">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="agreeClose">取 消</el-button>
        <el-button type="primary" class="enter-btn" @click="sumbitAgree()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 拒绝退款 -->
    <el-dialog
      :visible.sync="refuseVisible"
      width="30%"
      :before-close="refuseClose"
      :show-close="false"
    >
      <div slot="title" class="title">
        <p>退款金额</p>
        <span @click="refuseClose"><i class="el-icon-close"></i></span>
      </div>
      <div class="refuse-box">
        <el-input
          type="textarea"
          :rows="4"
          placeholder="请输入拒绝原因"
          v-model="feedback"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="refuseClose">取 消</el-button>
        <el-button type="primary" class="enter-btn" @click="sumbitRefuse()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAfterSalesList, agreeAfter, refuseAfter } from "@/api/shop";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        orderNo: null,
        applyRefundStatus: "",
      },
      tableData: [],
      total: 0,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      value: "",
      itemInfo: {},
      moneyVisible: false,
      agreeVisible: false,
      refuseVisible: false,
      isReturnStock: 1,
      feedback: "",
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取订单列表
    async init() {
      const res = await getAfterSalesList(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.orderNo = "";
      this.queryParams.applyRefundStatus = "";
      this.queryParams.startTime = "";
      this.queryParams.endTime = "";
      this.queryParams.pageNum = 1;
      this.value = "";
      this.init();
    },
    timeChange(event) {
      // console.log(event);
      if (event) {
        this.queryParams.startTime = this.$moment(event)
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
        this.queryParams.endTime = this.$moment()
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss");
      } else {
        this.queryParams.startTime = "";
        this.queryParams.endTime = "";
      }
      // console.log(this.queryParams);
    },
    goDetails(id) {
      this.$router.push({
        path: "/orderdetails",
        query: {
          id,
        },
      });
    },
    checkMoney(row) {
      this.itemInfo = row;
      this.moneyVisible = true;
    },
    moneyClose() {
      this.moneyVisible = false;
    },
    goAgree(row) {
      this.itemInfo = row;
      this.agreeVisible = true;
    },
    agreeClose() {
      this.agreeVisible = false;
    },
    async sumbitAgree() {
      const params = {
        id: this.itemInfo.id,
        isReturnStock: this.isReturnStock,
      };
      await agreeAfter(params);
      this.agreeVisible = false;
      this.init();
    },
    goRefuse(row) {
      this.itemInfo = row;
      this.refuseVisible = true;
    },
    refuseClose() {
      this.refuseVisible = false;
    },
    async sumbitRefuse() {
      const params = {
        id: this.itemInfo.id,
        feedback: this.feedback,
      };
      await refuseAfter(params);
      this.refuseVisible = false;
      this.init();
    },
  },
};
</script>
<style lang="scss" scoped>
.order {
  position: relative;
  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    ::v-deep .querybox {
      display: flex;
      align-items: center;

      > div {
        display: flex;
        align-items: center;
        margin-right: 24px;
        > span {
          display: block;
          width: 15px;
          height: 1px;
          background: #979797;
          margin: 0 6px;
        }
        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
          min-width: 80px;
        }
        .el-input,
        .el-range-editor {
          width: 216px;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(0, 0, 0, 0.25);
        }
        .el-input__inner {
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
      }
    }
    .handlebox {
      display: flex;
      align-items: center;
    }
  }
  .money-box {
    p {
      font-weight: 400;
      font-size: 14px;
      color: rgba(51, 51, 51, 0.85);
      line-height: 20px;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      span {
        display: block;
      }
    }
  }
  ::v-deep .agree-box {
    width: 100%;
    > div {
      font-weight: 400;
      font-size: 14px;
      color: rgba(51, 51, 51, 0.85);
      line-height: 20px;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      p {
        min-width: 100px;
        text-align: right;
      }
    }
    > div:last-child {
      margin: 0;
    }
    .el-radio {
      font-weight: 400;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.85);
      line-height: 22px;
      .el-radio__label {
        color: rgba(0, 0, 0, 0.85);
      }
      .el-radio__inner {
        width: 16px;
        height: 16px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #d9d9d9;
      }
      .is-checked {
        .el-radio__inner {
          border: 1px solid #ff5d2f;
        }
        .el-radio__inner::after {
          width: 8px;
          height: 8px;
          background: #ff5d2f;
        }
      }
    }
    input[aria-hidden="true"] {
      display: none !important;
    }

    .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
      .el-radio__inner {
      box-shadow: none !important;
    }
  }
}
</style>
